export default "__VITE_ASSET__1236235a__"